import axios from '../base/axios';
import API_KEY from './key';

const GET_FANTASY = 'flixfrenzy/redux/GET_FANTASY';

// eslint-disable-next-line default-param-last
const fantasyReducer = (state = [], action) => {
  switch (action.type) {
    case GET_FANTASY:
      return action.payload;
    default:
      return state;
  }
};

export const getFantasy = () => (dispatch) => {
  axios.get(`discover/movie?api_key=${API_KEY}&with_genres=14`).then((res) => {
    dispatch({
      type: GET_FANTASY,
      payload: res.data,
    });
  });
};

export default fantasyReducer;
